/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Timeline/Resource
 * @desc ExperimentWorkflow Timeline Resource component
 */

import { EntityLink } from 'labstep-web/components/Entity/Link';
import { EntityUserActionManageList } from 'labstep-web/components/EntityUser/Action/Manage/List';
import { ExperimentWorkflowActionMenu } from 'labstep-web/components/ExperimentWorkflow/Action/Menu';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { Flex } from 'labstep-web/core/Flex';
import type { IconProps } from 'labstep-web/core/Icon/types';
import type React from 'react';
import styles from './styles.module.scss';
import type { IExperimentWorkflowTimelineEventProps } from './types';

export const ExperimentWorkflowTimelineResource: React.FC<
  IExperimentWorkflowTimelineEventProps
> = ({ experimentWorkflow, actions, onClick, arrowAction }) => (
  <div className={styles.eventCard}>
    <Flex vAlignContent="center">
      <div className={styles.title}>
        <EntityLink entity={experimentWorkflow} editableName />
      </div>
      {arrowAction && (
        <div className={styles.arrowAction}>
          <ActionComponent
            type="icon"
            icon={`arrow ${arrowAction}` as IconProps['name']}
            onClick={() => {
              if (onClick) {
                onClick(experimentWorkflow);
              }
            }}
            elementProps={{ popup: { content: 'View on Timeline' } }}
          />
        </div>
      )}
      <div className={styles.right}>
        <EntityUserActionManageList
          entity={experimentWorkflow}
          hidePopup
        />
        <ExperimentWorkflowActionMenu
          experimentWorkflow={experimentWorkflow}
          actions={actions || []}
        />
      </div>
    </Flex>
  </div>
);
